/*
 *   File : basket-card.js
 *   Author : https://evoqins.com
 *   Description : basket card component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons";

export default function BasketCard({ data, type = 1, isSelected }) {

  return (
    <div className=" w-100 e-border border-deep-sea-green bg-white bg-opacity-43 p-3 rounded-20 d-flex rg-14">
      <div className="d-flex flex-column row-gap-3 w-100">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex column-gap-2 align-items-center">
            {type === 1 ? (
              <img
                src={data.img || data.image}
                alt={data.title || data.name}
                width={32}
                className="rounded-8"
              />
            ) : (
              <div className="d-flex rounded-8 border border-white justify-content-center align-items-center">
                <img
                  src={data.img}
                  alt={data.title}
                  width={32}
                  className=" rounded-8"
                />
              </div>
            )}

            <h5 className="mb-0 fw-500 fs-12 lh-18 text-eerie-black text-capitalize">
              {data.title || data.name}
            </h5>
          </div>
          <div className="d-flex column-gap-2 align-items-center">
            <Link
              className="fs-12 w-100 fw-500 lh-0 text-facebook-blue e-line-bottom-dashed-blue "
              to={`/manage-basket/detail/${data?.id}`}
            >
              View detail
            </Link>
            {type === 2 && (
              <Icon icon={isSelected ? "selected" : "unselect"} size={16} />
            )}
          </div>
        </div>
        <div className="d-flex justify-content-between ">
          <div className="d-flex flex-column ">
            <h5 className="fw-400 fs-12 lh-20 text-davys-gray mb-0">
              {data.return_year || data.raw.return_year} CAGR
            </h5>
            <h4 className="fw-500 fs-12 lh-20 text-medium-sea-green mb-0">
              {data.CAGR || data.return_percentage}%
            </h4>
          </div>
          <div className="d-flex flex-column ">
            <h5 className="fw-400 fs-12 lh-20 text-davys-gray mb-0">
              Best For
            </h5>
            <h4 className="fw-500 fs-12 lh-20 text-eerie-black mb-0">
              {data.best_for}
            </h4>
          </div>
          <div className="d-flex flex-column ">
            <h5 className="fw-400 fs-12 lh-20 text-davys-gray mb-0">Risk</h5>
            <h4 className="fw-500 fs-12 lh-20 text-eerie-black mb-0">
              {data.risk}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
